import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export interface WhatsNewVersion {
  version: string;
  messageMarkup: string;
}

export interface WhatsNewModalProps {
  open: boolean;
  onClose: () => void;

  version: string;
  versions: WhatsNewVersion[];
}

export const WhatsNewModal = (props: WhatsNewModalProps) => {
  const { open, onClose, version, versions } = props;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={'sm'}>
      <DialogTitle>Nous avons du nouveau pour vous... (v{version})</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Voici les fonctionnalités ajoutées depuis votre dernière visite.
        </DialogContentText>
        {versions.map((v) => (
          <DialogContentText key={v.version} sx={{ marginTop: 2 }}>
            <Box
              component="span"
              sx={{
                color: (theme) =>
                  theme.palette.getContrastText(theme.palette.background.paper),
                fontWeight: 'bold',
              }}
            >
              Version {v.version}
            </Box>
            <br />
            <span dangerouslySetInnerHTML={{ __html: v.messageMarkup }} />
          </DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        <Button variant={'contained'} color={'primary'} onClick={onClose}>
          D&apos;accord
        </Button>
      </DialogActions>
    </Dialog>
  );
};
